import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col } from "antd";
import { FileAddOutlined, EditOutlined } from "@ant-design/icons";

import { useEditorContext } from "../../hooks/useEditorContext";
import AddCommunicationModal from "../ModalForm/Member/AddCommunicationModal";

import PDFPreview from "../../components/PdfPreview";

interface Documents {
  groupId?: any;
  memberId?: any;
  documents: any;
  handleAddDocument?: Function;
}

const CommunicationList: React.FC<Documents> = ({
  groupId,
  memberId,
  documents,
  handleAddDocument,
}) => {
  const { setEditorContent, setEditorUpdate } = useEditorContext();
  const [show, setShow] = useState(false);

  const navigate = useNavigate();

  const handleAdd = () => {
    if (memberId) {
      setShow(true);
    } else {
      setEditorUpdate(false);
      setEditorContent("");
      navigate(`/groups/${groupId}/communication`);
    }
  };

  const handleEdit = (document: any) => {
    setEditorContent(document);
    setEditorUpdate(true);
    navigate(`/groups/${groupId}/communication`);
  };

  const showModal = () => {
    setShow(!show);
  };

  return (
    <>
      {documents.map((document: any) => (
        <Col span={4} key={document.id}>
          <div className="document-item">
            <h5>{document.Name}</h5>
            {memberId && <PDFPreview pdfUrl={document.Link} />}

            {groupId && (
              <EditOutlined
                className="document-edit"
                onClick={() => handleEdit({ ...document })}
              />
            )}
          </div>
        </Col>
      ))}

      <Col span={4} onClick={handleAdd}>
        <div className="document-item-add">
          <FileAddOutlined className="document-icon" />
        </div>
      </Col>

      <AddCommunicationModal
        show={show}
        showModal={showModal}
        handleAdd={handleAddDocument}
        memberId={memberId}
      />
    </>
  );
};

export default CommunicationList;
